module.exports = __webpack_public_path__ + "img/about_logo_02.e24983c7.png";